import FragmentDataType from "../enums/fragment-data-type";
import KickRecovered from "./kick-recovered";
import { FragmentMessages } from "../../common/fragment-messages";

export default class KickNotRecovered extends KickRecovered {
    constructor(recoveredBy, recoveredAt) {
        super(recoveredBy, recoveredAt);

        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }
}
